'use client';

import { useLinkStatus } from 'next/link';

import { Icon, type IconName } from '@eliadmin/core/src/components/nt/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Icon of a link that spins while the link's navigation is pending (a server-rendered list page).
 * Must be rendered inside the link.
 */
export function LinkPendingIcon({ name, size }: { name: IconName; size: number }) {
  const { pending } = useLinkStatus();
  return (
    <Icon
      name={name}
      size={size}
      className={cn(pending && 'animate-spin motion-reduce:animate-none')}
    />
  );
}
